"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filter = _interopRequireDefault(require("lodash/filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, _getPrototypeOf(Component).apply(this, arguments));
  }

  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          allowAdd = _this$props.allowAdd,
          allowRemove = _this$props.allowRemove,
          type = _this$props.type,
          inputStyle = _this$props.inputStyle;
      return _react.default.createElement("div", null, allowAdd && _react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          field.onChange([].concat(_toConsumableArray(field.value), ['']));
        }
      }, _react.default.createElement("span", {
        className: "glyphicon glyphicon-plus"
      })), _react.default.createElement("ol", null, field.value.map(function (value, index) {
        return _react.default.createElement("li", {
          key: index
        }, allowRemove && _react.default.createElement("button", {
          type: "button",
          onClick: function onClick() {
            field.onChange((0, _filter.default)(field.value, function (item, i) {
              return i !== index;
            }));
          }
        }, _react.default.createElement("span", {
          className: "glyphicon glyphicon-trash"
        })), "\xA0", _react.default.createElement("input", {
          type: type,
          style: inputStyle,
          value: field.value[index],
          onChange: function onChange(e) {
            field.onChange(field.value.map(function (item, i) {
              if (i === index) return e.target.value;
              return item;
            }));
          }
        }));
      })));
    }
  }]);

  return Component;
}(_react.default.Component);

exports.default = Component;

_defineProperty(Component, "propTypes", {
  field: _propTypes.default.object.isRequired,
  allowAdd: _propTypes.default.bool,
  allowRemove: _propTypes.default.bool,
  type: _propTypes.default.string,
  inputStyle: _propTypes.default.object
});

_defineProperty(Component, "defaultProps", {
  allowAdd: true,
  allowRemove: true,
  type: 'text',
  // any input tage type
  inputStyle: {}
});